/*
 * Authors: mariushirjanu
 * Created: 11/08/2021
 */
import { Injectable } from '@angular/core';
import { HttpDataService } from '../../shared/http/http-data.service';
import { ICompanyCountry } from '../../../type_definitions/datatypes';

@Injectable()
export class CompanyProfileDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
  }

  public loadCompanyCountry(companyCountryId:number):Promise<ICompanyCountry> {
    return this.httpDataService.doGET(
      `rest/compman/companycountries/${companyCountryId}`,
      undefined,
      undefined,
      'Error loading company'
    );
  }
}